module.exports = __webpack_public_path__ + "TextaNarrow-Regular-webfont.fb158543c5cc137adad8.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Regular-webfont.woff
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Regular-webfont.woff
// module chunks = styles